const PROJECT_TYPE = 'rocky';


// GET_RESULT_CONTENT,
//   UPDATE_VERIFICATION
export const GET_RESULT_CONTENT = `${PROJECT_TYPE}/get_sweep_result_content`;
export const UPDATE_VERIFICATION = `${PROJECT_TYPE}/update_sweep_verification`;